module.exports = __webpack_public_path__ + "img/湖北贝母.3e3b2d4a.jpg";